import React, { useMemo } from "react";
import { Checkbox, Tooltip } from "antd";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useSelector } from "react-redux";
import {
  have_product_reference,
  supplyingCount,
} from "../../../../../helpers/OrdersFunctionsGlobal";
import { returnEuroString } from "../../../../../helpers/Utils";
import { CheckBoxInput } from "../../../../../components/common/Buttons";
import SupplyingTableIndex from "../SupplyingTableIndex";

const OrderRow = ({
  type = "basic",
  id,
  childs,
  order_id,
  id_order,
  parent_id,
  product_reference,
  quantity,
  contract_items_count,
  shipments_count,
  user_title,
  manual,
  product_name,
  required_serial_number,
  serial_number,
  supplyings,
  invoicesTotal,
  handleCheck,
  handleSelected,
  unit_price_tax_incl,
  manual_disabled,
  product_info,
  pickedSupplierId,
}) => {
  // missed order id ?>

  const user_suppliers = useSelector(
    (state) => state.filters.orders.user_suppliers
  );

  const its_product = useMemo(
    () => have_product_reference(product_reference),
    [product_reference]
  );

  const supplying_count = useMemo(
    () => supplyingCount(supplyings),
    [supplyings?.length]
  );

  const isSupplying = useMemo(
    () =>
      supplyings?.length > 0 &&
      supplyings[0]?.supplier_id !== 22 &&
      (user_suppliers?.some(
        (supplierId) => supplyings[0]?.supplier_id === supplierId
      ) ||
        supplyings[0]?.supplier_id === pickedSupplierId?.value) &&
      product_info?.product_suppliers
        ?.filter((supplier) => supplier.quantity > 0)
        ?.some(
          (supplier) => supplier.supplier.id === supplyings[0]?.supplier_id
        ) &&
      user_suppliers?.some((supplierId) =>
        product_info?.product_suppliers
          ?.filter((supplier) => supplier.quantity > 0)
          ?.some((supplier) => supplier.supplier.id === supplierId)
      ),
    [supplyings, user_suppliers, pickedSupplierId, product_info]
  );

  return (
    <div className={`d-flex flex-column text-sm mb-2`} key={`order_row_${id}`}>
      <span
        className={`d-flex flex-column flex-wrap border-left ${invoicesTotal.includes(id) ? "border-success" : "border-danger"
          }`}
      >
        <div className="pl-1 d-flex align-items-center">
          {its_product && (
            <>
              <span
                className={
                  supplying_count == parseInt(quantity)
                    ? "text-success"
                    : "text-danger"
                }
              >
                [SU:{supplying_count}]
              </span>
              <span
                className={
                  shipments_count && shipments_count >= supplying_count
                    ? "text-success"
                    : "text-danger"
                }
              >
                [S:{shipments_count}]
              </span>

              <span
                className={
                  contract_items_count > 0 ? "text-success" : "text-danger"
                }
              >
                [C:{contract_items_count}]
              </span>
              <span
                className="px-2"
                style={{
                  backdropFilter: isSupplying ? "blur(5px)" : "none",
                  backgroundColor: isSupplying ? "#FFE7125E" : "inherit",
                }}
              >
                {product_reference}
              </span>
              <span className="d-flex">
                {product_info?.delivery_date &&
                  product_info.delivery_date.trim() !== "" && (
                    <>
                      <Tooltip placement="top" title={String(id_order)?.length > 12 ? "Must shipped out" : "Must Deliver to client"}>
                        <span className="eta-badge">
                          <span className="eta-text">{String(id_order)?.length > 12 ? "MSO" : "MDC"}</span>
                        </span>
                      </Tooltip>

                      <p className="eta-delivery-time">
                        {product_info.delivery_date}
                      </p>
                    </>
                  )}
              </span>
            </>
          )}
        </div>
        {/* preview */}
        <div className="d-flex align-items-center justify-content-between pl-1">
          <div
            className="pr-1 text-sm"
            style={{
              width: 230,
            }}
          >
            {user_title ? (
              <div
                style={{
                  maxWidth: 220,
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                }}
              >
                <Tooltip placement="top" title={user_title}>
                  <span
                    className={manual ? "border-bottom border-warning" : null}
                  >
                    {its_product ? (
                      <Checkbox
                        disabled={manual_disabled}
                        className="checkbox_blue mr-2"
                        checked={handleSelected("order_row", id)}
                        onChange={() =>
                          handleCheck("order_row", {
                            order_id,
                            order_row_id: id,
                          })
                        }
                      />
                    ) : (
                      <AiOutlineCheckCircle
                        className={`text-${parent_id ? "success" : "danger"
                          } mr-1`}
                      />
                    )}
                    {product_name}
                  </span>
                </Tooltip>
              </div>
            ) : (
              <div
                style={{
                  maxWidth: 220,
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                }}
                className={manual ? "border-bottom border-warning" : null}
              >
                {its_product ? (
                  <Checkbox
                    disabled={manual_disabled}
                    className="checkbox_blue mr-2"
                    checked={handleSelected("order_row", id)}
                    onChange={() =>
                      handleCheck("order_row", { order_id, order_row_id: id })
                    }
                  />
                ) : (
                  <AiOutlineCheckCircle
                    className={`text-${parent_id ? "success" : "danger"} mr-1`}
                  />
                )}
                {product_name}
              </div>
            )}
          </div>
          <div
            className="px-1  text-right"
            style={{
              width: 30,
            }}
          >
            {parseInt(quantity)}
          </div>
          <div
            className="text-right"
            style={{
              width: 60,
              whiteSpace: "nowrap",
            }}
          >
            {returnEuroString(unit_price_tax_incl)}
          </div>
        </div>
        {/* preview end */}
        {childs &&
          childs.map((child) => (
            <OrderRow
              key={`child_order_row_${child.id}`}
              {...child}
              id_order={id_order}
              invoicesTotal={invoicesTotal}
              handleCheck={handleCheck}
              handleSelected={handleSelected}
            />
          ))}
      </span>
      {required_serial_number && !serial_number && (
        <div className="text-danger">Required S/N</div>
      )}
      {type == "basic" && !!supplyings.length && (
        <table>
          <tbody style={{ fontWeight: "400" }}>
            {supplyings.map((itemSup) => (
              <SupplyingTableIndex
                key={"supply_index_" + itemSup.id}
                item={itemSup}
                // deleteSupply={this.deleteSupply}
                product_reference={product_reference}
                id_order_row={id}
              >
                <div className="mr-2">
                  <CheckBoxInput
                    disabled={itemSup.manual_disabled}
                    onChange={() =>
                      handleCheck("supplying", {
                        supplying_id: itemSup.id,
                        order_row_id: id,
                        order_id,
                      })
                    }
                    checked={handleSelected("supplying", itemSup.id)}
                  />
                </div>
              </SupplyingTableIndex>
            ))}
          </tbody>
        </table>
      )}
      {/* {manual_disabled && (
        <div className="text-xl text-danger">Disablintas rankiniu</div>
      )} */}
    </div>
  );
};

export default OrderRow;
